import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { businessInfo } from '../mockData';

export const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show button after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip for first time visitors
      const hasSeenTooltip = localStorage.getItem('whatsapp-tooltip-seen');
      if (!hasSeenTooltip) {
        setShowTooltip(true);
        setTimeout(() => {
          setShowTooltip(false);
          localStorage.setItem('whatsapp-tooltip-seen', 'true');
        }, 5000);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const openWhatsApp = () => {
    const message = encodeURIComponent('Hallo, ich interessiere mich für Ihre KFZ-Zulassungsservices.');
    window.open(`https://wa.me/${businessInfo.whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}>
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-20 right-0 bg-white rounded-lg shadow-xl p-4 w-64 animate-in fade-in slide-in-from-bottom-2">
            <button 
              onClick={() => setShowTooltip(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            >
              <X className="w-4 h-4" />
            </button>
            <p className="text-sm font-semibold text-gray-900 mb-1">
              Fragen zur Zulassung?
            </p>
            <p className="text-xs text-gray-600">
              Schreiben Sie uns direkt per WhatsApp!
            </p>
          </div>
        )}

        {/* Button */}
        <button
          onClick={openWhatsApp}
          className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 active:scale-95"
          aria-label="WhatsApp kontaktieren"
        >
          {/* Ping Animation */}
          <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></span>
          
          {/* Icon */}
          <MessageCircle className="w-8 h-8 relative z-10" />
          
          {/* Badge */}
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
            1
          </span>
        </button>
      </div>
    </>
  );
};
